import { BaseService } from "./BaseService";
import { CannedResponse } from "@/types/cannedResponse";
import {
  ICannedResponseService,
  CannedResponseFilters,
  CreateCannedResponseDto,
  UpdateCannedResponseDto,
  CannedResponseFindAllResponse,
} from "./interfaces/ICannedResponseService";
import { ReorderDto } from "./interfaces/ICategoryService";

class CannedResponseService
  extends BaseService
  implements ICannedResponseService
{
  private basePath = "/canned-responses";

  constructor() {
    super();
  }

  async getAll(
    filters: CannedResponseFilters,
  ): Promise<CannedResponseFindAllResponse> {
    return this.get<CannedResponseFindAllResponse>(this.basePath, filters);
  }

  async create(data: CreateCannedResponseDto): Promise<CannedResponse> {
    return this.post<CannedResponse>(this.basePath, data);
  }

  async update(
    id: string,
    data: UpdateCannedResponseDto,
  ): Promise<CannedResponse> {
    return this.patch<CannedResponse>(`${this.basePath}/${id}`, data);
  }

  async deleteCannedResponse(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }

  async reorder(data: ReorderDto): Promise<void> {
    return this.post<void>(`${this.basePath}/reorder`, data);
  }
}

export const cannedResponseService = new CannedResponseService();
